import {Pipe, PipeTransform} from '@angular/core';
import { repeat } from 'rxjs/operators';

@Pipe({
  name: 'prettyjson',
  pure: false,
})
export class PrettyJsonPipe implements PipeTransform {
  public transform(obj: any, spaces = 2): string {
   
   let result = '';
   const json = (typeof obj !== 'string') ? JSON.stringify(obj, undefined, 0) : obj;
   if (Object.keys(obj).length > json.length - 3){
      result = result + '<div class="card notitle">' + this._cleanString(((typeof obj !== 'string') ? JSON.stringify(obj, undefined, spaces) : obj), spaces) + '</div>';
   }
   else{
      Object.keys(obj).forEach((key) => {
         result = result + '<div class="card"><div class="title">' + key + '</div>' + this._syntaxHighlight(obj[key], spaces) + '</div>';
      });
   }
   return result;
  }

  private _syntaxHighlight(json: any, spacing: number): string {
    if (json === undefined) {
        return '<span class="undefined"></span>';
    }
    
    // Credits to the accepted answer here
    // http://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
    if (typeof json !== 'string') {
      json = JSON.stringify(json, undefined, spacing);
    }
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const s = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match: any) => {
        let cls = 'number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = 'key';
                match = match.replace(/"/g, '');
            } else {
                cls = 'string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return `<span class="${cls}">${match}</span>`;
    });
    return this._cleanString(s, spacing);
  }

  private _cleanString(s: string, spacing: number): string{
    return s.replace(/\s+},\s{3}/g, '}')
    // return s.replace(/\s+},\s{3}/g, '<div></div>' + ' '.repeat(spacing - 1) + '}')
    .replace(/({)/gi, '<div class="json">')
    // .replace(/({)/gi, '<div style="margin-top:-24px;padding-left:' + (spacing * 6) + '">')
    .replace(/(})/gi, '</div>').replace(/({|})/gi, '');
  }
}